// Shared styles configuration that can be imported across components
export const sharedStyles = {
  // Card styles
  card: {
    borderRadius: 3,
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    border: "1px solid",
    borderColor: "rgba(0,0,0,0.05)",
    height: "100%",
  },

  // Content wrapper styles
  contentWrapper: {
    p: 3,
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
  },

  // Header styles
  headerCard: {
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    border: "1px solid",
    borderColor: "rgba(0,0,0,0.05)",
    mb: 3,
    p: 2,
  },

  // Title styles
  title: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#1e293b",
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 2,
  },

  // Icon styles
  icon: {
    color: "#3b82f6",
    fontSize: "1.5rem",
  },
  
  smallIcon: {
    color: "#3b82f6",
    fontSize: "1.25rem",
  },

  // Label and value styles
  infoLabel: {
    color: "#64748b",
    fontSize: "0.875rem",
    fontWeight: "500",
  },

  infoValue: {
    color: "#1e293b",
    fontSize: "0.875rem",
    fontWeight: "500",
  },

  // Grid container styles
  gridContainer: {
    spacing: 3,
    mb: 3,
  },

  // Content card styles
  contentCard: {
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    border: "1px solid",
    borderColor: "rgba(0,0,0,0.05)",
    height: "100%",
    p: 2,
  },

  // Scrollable container styles
  scrollableContainer: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "4px",
      backgroundColor: "#888",
    },
  },

  // Chip styles
  chip: {
    backgroundColor: "#ECEBFB",
    color: "#000000",
    fontWeight: "500",
    fontSize: "0.75rem",
    borderRadius: "16px",
    m: 0.5,
  },

  // Avatar styles
  avatar: {
    width: 60,
    height: 60,
  },

  // Navigation button styles
  navButton: {
    borderRadius: "50%",
    backgroundColor: "#EEF4FE",
    padding: "8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#DCE7FD",
    },
  },

  // Status styles
  status: (status: any) => ({
    display: "inline-flex",
    alignItems: "center",
    px: 2,
    py: 0.5,
    borderRadius: "9999px",
    fontSize: "0.75rem",
    fontWeight: "500",
    ml: 1,
    backgroundColor: status === "Active" ? "#dcfce7" : "#fee2e2",
    color: status === "Active" ? "#166534" : "#991b1b",
  }),
};

// Helper functions
export const formatDate = (date: any) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

export const getValue = (value:any, defaultValue = "N/A") => value || defaultValue;

export default sharedStyles;